import type { Clip } from "@hudhud/core";
import { HEIGHT, WIDTH } from "../types.js";
import { clampMap } from "./interpolate.js";

export const LOGO_PAD = 44;
export interface LogoAnchorBox { left?: number; right?: number; top?: number; bottom?: number }

/** Where the logo sits for each anchor, before the nudge. */
export function logoAnchor(anchor: Clip["brand"]["logo"]): { style: LogoAnchorBox; centreX: boolean; centreY: boolean } {
  const PAD = LOGO_PAD;
  switch (anchor) {
    case "tl": return { style: { left: PAD, top: PAD + 6 }, centreX: false, centreY: false };
    case "tr": return { style: { right: PAD, top: PAD + 6 }, centreX: false, centreY: false };
    case "tc": return { style: { left: WIDTH / 2, top: PAD + 6 }, centreX: true, centreY: false };
    case "ml": return { style: { left: PAD, top: HEIGHT / 2 }, centreX: false, centreY: true };
    case "mr": return { style: { right: PAD, top: HEIGHT / 2 }, centreX: false, centreY: true };
    case "bl": return { style: { left: PAD, bottom: HEIGHT * 0.09 }, centreX: false, centreY: false };
    case "br": return { style: { right: PAD, bottom: HEIGHT * 0.09 }, centreX: false, centreY: false };
    default: return { style: { left: WIDTH / 2, bottom: HEIGHT * 0.075 }, centreX: true, centreY: false };
  }
}

/** The logo fades in over frames 20–90 to its set opacity. */
export const logoOpacityAt = (frame: number, max: number) => clampMap(frame, [20, 90], [0, max]);
export const logoWidth = (scale: number) => 260 * scale;

/** The logo's top-left corner on the canvas for its anchor, size and nudge (centred anchors resolved), so any renderer places it the same. */
export function logoPosition(brand: Clip["brand"], w: number, h: number): { left: number; top: number } {
  const { style, centreX, centreY } = logoAnchor(brand.logo);
  let left = style.left ?? (style.right !== undefined ? WIDTH - style.right - w : 0);
  let top = style.top ?? (style.bottom !== undefined ? HEIGHT - style.bottom - h : 0);
  if (centreX) left -= w / 2;
  if (centreY) top -= h / 2;
  return { left: left + brand.logoX, top: top + brand.logoY };
}
